import React from "react"
import { MyCardHelpers } from "@macashipo/mlib"

const MC_card_row_email_template = React.lazy(() =>
  import("./Types/card_row_email_template")
)
const MC_card_html = React.lazy(() => import("./Types/card_html"))

//crmhf
const MC_card_crmhf_task = React.lazy(() =>
  import("./Types_crmhf/card_crmhf_task")
)

const List = {
  card_row_email_template: MC_card_row_email_template,
  card_html: MC_card_html,
  //crmhf
  card_crmhf_task: MC_card_crmhf_task,
}
const MyLibOne = {
  init() {
    MyCardHelpers.addTypesFromListLazy(List)
  },
}

export default MyLibOne
